export default "__VITE_ASSET__PlKQLTpq__"